export default __webpack_public_path__ + "static/media/kh.ca3f48d2.svg";